import React, { ReactNode } from "react";
import * as ReactTooltip from "@radix-ui/react-tooltip";
import styles from "./Tooltip.module.scss";

interface Props {
  children: ReactNode;
  content: string;
  delay?: number;
  maxWidth?: number;
}

const Tooltip: React.FC<Props> = ({ children, content, delay, maxWidth }) => {
  return (
    <ReactTooltip.Provider>
      <ReactTooltip.Root delayDuration={delay ?? 300}>
        <ReactTooltip.Trigger asChild>{children}</ReactTooltip.Trigger>
        <ReactTooltip.Portal>
          <ReactTooltip.Content
            style={{ maxWidth }}
            sideOffset={4}
            className={styles.content}
          >
            {content}
            <ReactTooltip.Arrow className={styles.arrow} />
          </ReactTooltip.Content>
        </ReactTooltip.Portal>
      </ReactTooltip.Root>
    </ReactTooltip.Provider>
  );
};

export default Tooltip;
